<template>
  <div id="contenedor-clientes-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ClientesMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
